__turbopack_context__.v({
  "wrapper": "Sort-module__SiG0_q__wrapper",
});
